export function getView(search) {
  return search?.trim() ? 'Search' : 'Default'
}
